import { Head, router } from "@inertiajs/react"
import { Calendar, CheckCircle, Clock, MapPin } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import type { TryoutsRegistrationsShow } from "@/types/serializers"

function formatTime(timeStr: string): string {
  // Time columns serialize as "2000-01-01T09:00:00.000Z" — extract HH:MM
  const match = timeStr.match(/T(\d{2}:\d{2})/)
  return match ? match[1] : timeStr.slice(0, 5)
}

export default function TryoutRegistrationShow({
  tryout,
  application,
}: TryoutsRegistrationsShow) {
  return (
    <>
      <Head title="Inscripción confirmada | KrownFT" />

      <div className="bg-background min-h-svh">
        <div className="mx-auto max-w-lg px-4 py-12">
          <div className="mb-8 text-center">
            <div className="bg-krown-accent/20 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
              <CheckCircle className="text-krown-accent h-8 w-8" />
            </div>
            <h1 className="mb-2 text-2xl font-bold text-white">
              ¡Inscripción confirmada!
            </h1>
            <p className="text-muted-foreground">
              Tu inscripción fue registrada exitosamente.
            </p>
          </div>

          <Card className="mb-6">
            <CardContent className="space-y-3 p-6">
              <h2 className="font-semibold text-white">{tryout.title}</h2>
              <p className="text-muted-foreground text-sm">
                {tryout.club_profile.name}
              </p>

              <div className="border-border space-y-2 border-t pt-3">
                <div className="flex items-center gap-2 text-sm">
                  <MapPin className="text-muted-foreground h-4 w-4" />
                  <span>{tryout.venue_name}</span>
                </div>
                {tryout.address && (
                  <div className="text-muted-foreground ml-6 text-sm">
                    {tryout.address}
                  </div>
                )}
                <div className="flex items-center gap-2 text-sm">
                  <Calendar className="text-muted-foreground h-4 w-4" />
                  <span>
                    Categoría {application.tryout_category.label} —{" "}
                    {new Date(
                      application.tryout_category.date + "T00:00:00",
                    ).toLocaleDateString("es-AR", {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Clock className="text-muted-foreground h-4 w-4" />
                  <span>
                    {formatTime(application.tryout_category.start_time)} -{" "}
                    {formatTime(application.tryout_category.end_time)}
                  </span>
                </div>
              </div>

              {application.guardian_name && (
                <div className="border-border border-t pt-3">
                  <p className="text-muted-foreground text-sm">
                    Tutor: {application.guardian_name}
                    {application.guardian_phone &&
                      ` (${application.guardian_phone})`}
                  </p>
                </div>
              )}
            </CardContent>
          </Card>

          <div className="space-y-3">
            <Button
              className="from-krown-orange-from to-krown-orange-to w-full bg-gradient-to-r"
              onClick={() => router.visit("/inicio")}
            >
              Ir al inicio
            </Button>
            <Button
              variant="outline"
              className="w-full"
              onClick={() => router.visit(`/pruebas/${tryout.slug}`)}
            >
              Ver la prueba
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
